import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-time",
  templateUrl: "./med-icon-time.component.html",
})
export class MedIconTimeComponent extends SvgMixinComponent {}
